<template>
  <div class="view-textlist" :id="field.key">
    <!-- Campo status con colores especiales usando el componente -->
    <ShippingStatusBadge
      v-if="field.key == 'status' && modelName == 'shipping' && item"
      :item="item"
      :model-name="modelName"
      size="small"
    />

    <span
      v-else-if="field.key == 'status' && modelName == 'shipping' && displayValue"
      class="shipping-status-badge"
      :class="getStatusClass(Number(displayValue))"
    >
      {{ getStatusLabel(Number(displayValue), $t) }}
    </span>

    <!-- Mostrar lista de texto como elementos separados -->
    <div
      v-else-if="field.isArray && Array.isArray(displayValue) && displayValue.length > 0"
      class="textlist-container"
    >
      <div v-for="(item, index) in displayValue" :key="index" class="textlist-item">
        <span class="textlist-bullet">•</span>
        <span class="textlist-text">{{ getTextListLabel(item) }}</span>
      </div>
    </div>

    <!-- Mostrar texto simple si no es array -->
    <div v-else-if="displayValue && !Array.isArray(displayValue)" class="textlist-single">
      {{ getTextListLabel(displayValue) }}
    </div>

    <!-- Mostrar mensaje si está vacío -->
    <div v-else class="textlist-empty">
      <em>{{ $t('No items') }}</em>
    </div>
  </div>
</template>

<script>
import ShippingStatusBadge from "../../common/ShippingStatusBadge.vue";
import { getStatusClass, getStatusLabel } from "@/utils/shippingStatus";

export default {
  name: "ViewFieldTextList",
  components: {
    ShippingStatusBadge,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array, Object],
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
    modelName: {
      type: String,
      default: "",
    },
    isGroupModel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.value;
      }
      if (this.field.defaultValue !== undefined && this.field.defaultValue !== null) {
        return this.field.defaultValue;
      }
      return null;
    },
  },
  methods: {
    getTextListLabel(value) {
      if (!value) return "";
      if (typeof value === "object" && value.label) {
        return value.label;
      }
      return this.$t(value) || String(value);
    },
    getStatusClass,
    getStatusLabel,
  },
};
</script>

<style scoped>
.view-textlist {
  font-weight: 500;
}

.textlist-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.textlist-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.textlist-bullet {
  color: #6c757d;
}

.textlist-text {
  color: #495057;
}

.textlist-single {
  color: #495057;
}

.textlist-empty {
  color: #6c757d;
  font-style: italic;
}
</style>

